module.exports = __webpack_public_path__ + "media/application/images/2018/2018-fav-plus-6dfd0c2509782d9f2f79204917c3ba58.jpg";